import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Typography } from '@one-thd/sui-atomic-components';

const DimensionSearchField = ({ label, value, onChange }) => (
  <>
    <div className="sui-mb-1">
      <Typography weight="bold">
        Search {label}:
      </Typography>
    </div>
    <div className="sui-mb-6">
      <TextField
        fullWidth
        placeholder="Search"
        id="fullWidth"
        value={value}
        onChange={onChange}
      />
    </div>
    <div className="sui-mb-3">
      <Typography weight="bold">All {label}:</Typography>
    </div>
  </>
);

DimensionSearchField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export { DimensionSearchField };